import qs from 'qs';
import toString from 'lodash/toString';

/**
 * Convert location query string to object
 * @returns {{}}
 */
export function getQueryParams() {
    return qs.parse(location.search.substr(1));
}

/**
 * Change query string of URL and pushes it to history stack
 *
 * @param {{}} newParams New query params
 * @param {bool} replace Push or replace history entry
 */
export function setQueryParams(newParams, replace = false) {
    const params = getQueryParams();
    if (Object.keys(newParams).some(key => toString(params[key]) !== toString(newParams[key]))) {
        history[replace ? 'replaceState' : 'pushState'](
            null, '', `?${qs.stringify(newParams)}`,
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/helpers/location.js